<template>
  <div class="grid grid-cols-7 items-center gap-4">
    <div class="col-span-7 flex flex-wrap items-center gap-4">
      <a
        v-if="publication?.status === 'published' && publicationLink"
        class="text-sm break-all text-indigo-600 underline"
        :href="publicationLink"
        target="_blank"
        >{{ publicationLink }}</a
      >
      <a
        v-if="storyblokPages?.length === 1"
        class="inline-flex items-center rounded-sm border border-[#09B3AF] bg-white px-2 py-1 text-xs font-medium text-[#09B3AF] hover:bg-[#09B3AF] hover:text-white focus:ring-2 focus:ring-[#09B3AF] focus:ring-offset-2 focus:outline-hidden"
        target="_blank"
        :href="`https://app.storyblok.com/#!/me/spaces/${storyblokSpace}/stories/0/0/${storyblokPages[0].id}`"
        ><svg
          class="mt-0.5 mr-2 h-6 w-6 self-start fill-current"
          viewBox="0 0 87 103"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          aria-label="Storyblok logo"
        >
          <g id="storyblok-logo" fill-rule="nonzero">
            <g>
              <path
                d="M51.8,49 L31,49 L31,59 L51.3,59 C52.5,59 53.6,58.5 54.5,57.7 C55.3,56.9 55.8,55.7 55.8,54.2 C55.8290035,52.9130708 55.4433501,51.6509323 54.7,50.6 C53.9,49.6 53,49 51.8,49 Z M52.5,36.9 C53.4,36.3 53.8,35 53.8,33.3 C53.8,31.8 53.4,30.7 52.7,30 C52,29.4 51.1,29 50.1,29 L31,29 L31,38 L49.7,38 C50.7,38 51.7,37.5 52.5,36.9 Z"
              />
              <path
                d="M83,0 L4.5,0 C2,0 0,2 0,4.4 L0,83 C0,85.4 2,86.9 4.4,86.9 L16,86.9 L16,102.6 L30.4,87 L83,87 C85.4,87 86.9,85.5 86.9,83 L86.9,4.5 C86.9,2.1 85.4,0.1 82.9,0.1 L83,0 Z M69.8,63.7 C68.8,65.5 67.3,67 65.5,68.1 C63.6,69.3 61.5,70.4 59.1,70.9 C56.7,71.5 54.1,72 51.4,72 L16,72 L16,16 L56.2,16 C58.2,16 59.9,16.4 61.5,17.3 C63,18.1 64.4,19.2 65.5,20.5 C67.7403434,23.2320077 68.9444137,26.6671496 68.9,30.2 C68.9,32.8 68.2,35.3 66.9,37.7 C65.5522265,40.1140117 63.4421536,42.0130773 60.9,43.1 C64.1,44 66.6,45.6 68.5,47.9 C70.3,50.3 71.2,53.4 71.2,57.3 C71.2,59.8 70.7,61.9 69.7,63.7 L69.8,63.7 Z"
              />
            </g>
          </g>
        </svg>
        {{ t('storyblokPages.view') }}</a
      >
      <Menu
        v-else-if="storyblokPages?.length"
        as="div"
        class="relative inline-block"
      >
        <MenuButton
          class="inline-flex items-center rounded-sm border border-[#09B3AF] bg-white px-2 py-1 text-xs font-medium text-[#09B3AF] hover:bg-[#09B3AF] hover:text-white focus:ring-2 focus:ring-[#09B3AF] focus:ring-offset-2 focus:outline-hidden"
          ><svg
            class="mt-0.5 mr-2 h-6 w-6 self-start fill-current"
            viewBox="0 0 87 103"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            aria-label="Storyblok logo"
          >
            <g id="storyblok-logo" fill-rule="nonzero">
              <g>
                <path
                  d="M51.8,49 L31,49 L31,59 L51.3,59 C52.5,59 53.6,58.5 54.5,57.7 C55.3,56.9 55.8,55.7 55.8,54.2 C55.8290035,52.9130708 55.4433501,51.6509323 54.7,50.6 C53.9,49.6 53,49 51.8,49 Z M52.5,36.9 C53.4,36.3 53.8,35 53.8,33.3 C53.8,31.8 53.4,30.7 52.7,30 C52,29.4 51.1,29 50.1,29 L31,29 L31,38 L49.7,38 C50.7,38 51.7,37.5 52.5,36.9 Z"
                />
                <path
                  d="M83,0 L4.5,0 C2,0 0,2 0,4.4 L0,83 C0,85.4 2,86.9 4.4,86.9 L16,86.9 L16,102.6 L30.4,87 L83,87 C85.4,87 86.9,85.5 86.9,83 L86.9,4.5 C86.9,2.1 85.4,0.1 82.9,0.1 L83,0 Z M69.8,63.7 C68.8,65.5 67.3,67 65.5,68.1 C63.6,69.3 61.5,70.4 59.1,70.9 C56.7,71.5 54.1,72 51.4,72 L16,72 L16,16 L56.2,16 C58.2,16 59.9,16.4 61.5,17.3 C63,18.1 64.4,19.2 65.5,20.5 C67.7403434,23.2320077 68.9444137,26.6671496 68.9,30.2 C68.9,32.8 68.2,35.3 66.9,37.7 C65.5522265,40.1140117 63.4421536,42.0130773 60.9,43.1 C64.1,44 66.6,45.6 68.5,47.9 C70.3,50.3 71.2,53.4 71.2,57.3 C71.2,59.8 70.7,61.9 69.7,63.7 L69.8,63.7 Z"
                />
              </g>
            </g>
          </svg>
          {{ t('storyblokPages.view') }}
          <ChevronDownIcon
            class="-mr-1 ml-2 h-5 w-5 text-gray-300 hover:text-gray-100"
            aria-hidden="true"
          />
        </MenuButton>
        <transition
          enterActiveClass="transition duration-100 ease-out"
          enterFromClass="transform scale-95 opacity-0"
          enterToClass="transform scale-100 opacity-100"
          leaveActiveClass="transition duration-75 ease-in"
          leaveFromClass="transform scale-100 opacity-100"
          leaveToClass="transform scale-95 opacity-0"
        >
          <MenuItems
            class="absolute left-0 z-10 mt-2 flex w-120 origin-top-right flex-col divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
          >
            <MenuItem
              v-for="story in storyblokPages"
              v-slot="{ active }"
              :key="story.id"
            >
              <div class="p-2 pl-3" :class="{ 'bg-indigo-50': active }">
                <a
                  class="flex items-center gap-1 text-sm break-all"
                  target="_blank"
                  :href="`https://app.storyblok.com/#!/me/spaces/${storyblokSpace}/stories/0/0/${story.id}`"
                >
                  {{ story.full_slug }}
                  <ArrowTopRightOnSquareIcon
                    class="ml-2 h-5 w-5 text-indigo-600"
                  />
                </a>
              </div>
            </MenuItem>
          </MenuItems>
        </transition>
      </Menu>
    </div>
    <div class="col-span-7 sm:col-span-3">
      <label for="startDate" class="block text-sm font-medium text-gray-700">{{
        t('vacancy.publication.start')
      }}</label>
      <date-picker
        :id="`startDate${publication.siteId}`"
        :value="startDate"
        type="dateTime"
        format="D MMM YYYY HH:mm"
        :disabledDate="disabledStartDate"
        :clearable="false"
        :editable="false"
        class="mt-1"
        @change="updateStartDate"
      />
    </div>

    <div v-show="!expirationDateHidden" class="col-span-7 sm:col-span-3">
      <label for="endDate" class="block text-sm font-medium text-gray-700">{{
        t('vacancy.publication.end')
      }}</label>
      <date-picker
        :id="`endDate${publication.siteId}`"
        :value="endDate"
        type="dateTime"
        format="D MMM YYYY HH:mm"
        :disabledDate="disabledEndDate"
        :clearable="false"
        :editable="false"
        class="mt-1"
        @change="updateEndDate"
      />
    </div>
    <div v-show="!expirationDateHidden" class="col-span-2 sm:col-span-1">
      <label
        :for="`days${publication.siteId}`"
        class="block text-sm font-medium text-gray-700"
        >{{ t('vacancy.publication.days') }}</label
      >
      <input
        :id="`days${publication.siteId}`"
        type="number"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-xs focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        :value="days"
        :min="minDays"
        @change="(e) => updateDays(parseInt(e.target.value) - 1)"
      />
    </div>
    <div class="col-span-3">
      <div
        class="relative flex items-start"
        :class="{ 'mt-5': expirationDateHidden }"
      >
        <div class="flex h-6 items-center">
          <input
            :id="`no-expiration${publication.siteId}`"
            name="no-expiration"
            type="checkbox"
            class="h-4 w-4 rounded-sm border-gray-300 text-indigo-600 focus:ring-indigo-600"
            :checked="expirationDateHidden"
            @change="toggleExpiration"
          />
        </div>
        <div class="ml-3 text-sm leading-6">
          <label
            :for="`no-expiration${publication.siteId}`"
            class="font-normal text-gray-900"
            >{{ t('vacancy.publication.noExpirationDate') }}</label
          >
        </div>
      </div>
    </div>
  </div>
  <PublicationApplicationUrl
    class="mt-6"
    :applicationUrl="publication[`${publication.scope}ApplicationUrl`]"
    :siteId="publication.siteId"
  />
  <div
    v-if="site.siteSlug.includes('werkenvoorlimburg-nl')"
    class="col-span-4 mt-6 md:col-span-2"
  >
    <label
      for="publicationScope"
      class="block text-sm font-medium text-gray-700"
      >{{ t('vacancy.publication.scope') }}</label
    >
    <select
      id="publicationScope"
      name="publicationScope"
      class="mt-1 block w-full rounded-md border-gray-300 py-2 pr-10 pl-3 text-base focus:border-indigo-500 focus:ring-indigo-500 focus:outline-hidden sm:text-sm"
      :value="publication.scope"
      @change="(e) => onScopeChange(e.target.value)"
    >
      <option value="external">
        {{ t('vacancy.publication.scopes.external') }}
      </option>
      <option value="regional">
        {{ t('vacancy.publication.scopes.regional') }}
      </option>
      <option value="internal">
        {{ t('vacancy.publication.scopes.internal') }}
      </option>
    </select>
  </div>
  <div class="mt-6 grid grid-cols-6 gap-4">
    <h3 class="block text-sm font-medium text-gray-700 uppercase">
      {{ t('vacancy.publication.tags') }}
    </h3>
    <PublicationTag
      v-for="tagGroup in siteTags"
      :key="tagGroup.id"
      :tagGroup="tagGroup"
      :selectedTags="publication.tags[tagGroup.id] || []"
      :siteId="publication.siteId"
    />
  </div>
  <div v-if="authStore.isAdmin" class="col-span-3 mt-5 mb-2 flex gap-8">
    <SwitchGroup>
      <div class="flex items-center">
        <Switch
          v-model="displayInList"
          :class="displayInList ? 'bg-indigo-600' : 'bg-gray-300'"
          class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
        >
          <span
            :class="displayInList ? 'translate-x-6' : 'translate-x-1'"
            class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform"
          ></span>
        </Switch>
        <SwitchLabel class="ml-2 text-sm font-medium text-gray-700">
          {{ t('vacancy.publication.displayInList') }}
        </SwitchLabel>
      </div>
    </SwitchGroup>
    <SwitchGroup>
      <div class="flex items-center">
        <Switch
          v-model="includeInLinkedInFeed"
          :disabled="!vacancyStore.linkedInConfigured"
          :class="includeInLinkedInFeed ? 'bg-indigo-600' : 'bg-gray-300'"
          class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
        >
          <span
            :class="includeInLinkedInFeed ? 'translate-x-6' : 'translate-x-1'"
            class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform"
          ></span>
        </Switch>
        <SwitchLabel
          class="ml-2 flex items-center gap-2 text-sm font-medium"
          :class="
            vacancyStore.linkedInConfigured ? 'text-gray-700' : 'text-gray-400'
          "
        >
          {{ t('vacancy.publication.includeInLinkedInFeed') }}
          <HelpPopover
            v-if="!vacancyStore.linkedInConfigured"
            :text="t('vacancy.publication.linkedInHint')"
          />
        </SwitchLabel>
      </div>
    </SwitchGroup>
  </div>
</template>

<script setup>
import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'
import PublicationApplicationUrl from './PublicationApplicationUrl.vue'
import { useVacancyStore } from '../../store/vacancyStore'
import { useSettingsStore } from '../../store/settingsStore'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import PublicationTag from './PublicationTag.vue'

import {
  endOfDay,
  isBefore,
  addDays,
  startOfDay,
  addMonths,
  differenceInDays,
} from 'date-fns'
import { useAuthStore } from '../../store/authStore'
import hydrateObject from '../../utils/hydrateObject'
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Switch,
  SwitchGroup,
  SwitchLabel,
} from '@headlessui/vue'
import {
  ArrowTopRightOnSquareIcon,
  ChevronDownIcon,
} from '@heroicons/vue/20/solid'
import HelpPopover from '../HelpPopover.vue'

const props = defineProps({
  publication: {
    type: Object,
    required: true,
  },
  site: {
    type: Object,
    required: true,
  },
  siteTags: {
    type: Array,
    required: true,
  },
})

const vacancyStore = useVacancyStore()
const settingsStore = useSettingsStore()
const authStore = useAuthStore()

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

const storyblokSpace = import.meta.env.VITE_STORYBLOK_SPACE

DatePicker.locale(settingsStore.locale)

const storyblokPages = ref([])

const publicationLink = computed(() => {
  if (!props.site.vacancyLinkFormat) return ''

  const context = { vacancy: vacancyStore.vacancy }
  const { vacancyUrl } = hydrateObject(
    { vacancyUrl: props.site.vacancyLinkFormat },
    context,
  )
  return vacancyUrl
})

const startDate = computed(() => {
  const date = props.publication[`${props.publication.scope}StartDate`]
  return date || null
})

const endDate = computed(() => {
  const date = props.publication[`${props.publication.scope}EndDate`]
  return date || null
})

const expirationDateHidden = computed(() => {
  return endDate.value > new Date(2999, 11, 1)
})

const days = computed(() => {
  return differenceInDays(endDate.value, startDate.value) + 1
})
const minDays = computed(() => {
  return differenceInDays(Date.now(), startDate.value) + 1
})

const includeInLinkedInFeed = computed({
  get() {
    return props.publication.includeInLinkedInFeed
  },
  set() {
    const publication = vacancyStore.publications.find(
      (p) => p.siteId === props.publication.siteId,
    )
    publication.includeInLinkedInFeed = !publication.includeInLinkedInFeed
  },
})

const displayInList = computed({
  get() {
    return props.publication[`${props.publication.scope}DisplayInList`]
  },
  set() {
    const publication = vacancyStore.publications.find(
      (p) => p.siteId === props.publication.siteId,
    )
    publication[`${publication.scope}DisplayInList`] =
      !publication[`${publication.scope}DisplayInList`]
  },
})

const updateDateRange = (newStartDate, newEndDate) => {
  const publication = vacancyStore.publications.find(
    (p) => p.siteId === props.publication.siteId,
  )
  publication[`${publication.scope}StartDate`] = newStartDate
  publication[`${publication.scope}EndDate`] = newEndDate
}

const toggleExpiration = () => {
  //All  publications with 'magic date' >= 2999-12-01 will appear without endDate on our sites.
  //If you reading this comment in 2999, this will require new solution
  //When disabling no ending publication, reset endDate to 1 month from now.
  if (!expirationDateHidden.value) {
    updateDateRange(startDate.value, new Date(2999, 11, 30))
  } else {
    updateDateRange(startDate.value, addMonths(new Date(), 1))
  }
}

const updateEndDate = (newEndDate) => {
  if (newEndDate) {
    updateDateRange(startDate.value, endOfDay(newEndDate))
  }
}
const updateStartDate = (newStartDate) => {
  updateDateRange(
    newStartDate,
    isBefore(newStartDate, endDate.value)
      ? endDate.value
      : endOfDay(newStartDate),
  )
}

const updateDays = (newDays) => {
  updateDateRange(startDate.value, endOfDay(addDays(startDate.value, newDays)))
}

const disabledStartDate = (date) => isBefore(date, startOfDay(new Date()))

const disabledEndDate = (date) => isBefore(date, startDate.value)

const onScopeChange = (scope) => {
  const publication = vacancyStore.publications.find(
    (p) => p.siteId === props.publication.siteId,
  )

  // We reset previous dates first
  const startDatePreviousScope = publication[`${publication.scope}StartDate`]
  const endDatePreviousScope = publication[`${publication.scope}EndDate`]
  const applicationUrlPreviousScope =
    publication[`${publication.scope}ApplicationUrl`]
  const displayInListPreviousScope =
    publication[`${publication.scope}DisplayInList`]

  const possibleScopes = ['external', 'regional', 'internal']
  possibleScopes.forEach((possibleScope) => {
    if (possibleScope !== scope) {
      publication[`${possibleScope}StartDate`] = null
      publication[`${possibleScope}EndDate`] = null
      publication[`${possibleScope}ApplicationUrl`] = null
    }
  })

  publication.scope = scope
  publication[`${publication.scope}StartDate`] = startDatePreviousScope
  publication[`${publication.scope}EndDate`] = endDatePreviousScope
  publication[`${publication.scope}ApplicationUrl`] =
    applicationUrlPreviousScope
  publication[`${publication.scope}DisplayInList`] = displayInListPreviousScope
}

onMounted(async () => {
  if (authStore.isAdmin) {
    storyblokPages.value = await vacancyStore.loadStoryblokPages(props.site)
  }
})
</script>
<style>
.mx-datepicker {
  width: 100%;
}
.mx-datepicker .mx-input {
  height: 38px;
}
</style>
